import { getLabelBreadCrumb, transformRootPath } from "../constants";

const formatRoot = ({ rootPath, replaceRoutes}: { rootPath: string[]; replaceRoutes?: unknown}) => {
    return rootPath.map( item => {
        const [path, label, id, search] = item.split('-')
        const result = search?.replace(/[{}]/g, '');
        const externalSearch = replaceRoutes?.[result ?? '']
        return {
            path: `/${transformRootPath?.[path] ?? path}${id ? '/' + id: ''}${externalSearch?.search || ''}`,
            label: getLabelBreadCrumb?.[label] ?? '-',
            state: externalSearch?.state
        }
    })
}

export { formatRoot }
